import eventAction from "@/store/eventAction";

function defaultState() {
  return {};
}
// state
const state = defaultState();

// getters
const getters = {};

// actions
const actions = {
  clear({ state }) {
    Object.assign(state, defaultState());
  },
  new({ dispatch }, { list, card, alarm }) {
    dispatch(
      "events/emit",
      {
        card: card,
        list: list,
        action: card ? eventAction.card.alarm.new : eventAction.list.alarm.new,
        data: {
          month_days: alarm.month_days,
          enabled: alarm.enabled,
          greeting: alarm.greeting,
          zone: alarm.zone
        },
        param2: alarm.time,
        param3: alarm.days
      },
      { root: true }
    );
  },

  update({ dispatch }, { list, card, oldAlarm, newAlarm }) {
    if (!oldAlarm || !newAlarm) return;

    if (
      oldAlarm.time == newAlarm.time &&
      oldAlarm.month_days == newAlarm.month_days &&
      oldAlarm.days == newAlarm.days &&
      oldAlarm.enabled == newAlarm.enabled &&
      oldAlarm.greeting == newAlarm.greeting &&
      oldAlarm.zone == newAlarm.zone
    ) {
      return;
    }

    dispatch(
      "events/emit",
      {
        list: list,
        card: card,
        action: card ? eventAction.card.alarm.update : eventAction.list.alarm.update,
        data: {
          month_days: newAlarm.month_days,
          enabled: newAlarm.enabled, //newAlarm.enabled ? "true" : null,
          greeting: newAlarm.greeting, // data2: newAlarm.greeting,
          zone: newAlarm.zone
        },
        param1: newAlarm.id,
        param2: newAlarm.time,
        param3: newAlarm.days
      },
      { root: true }
    );
  },

  handleEvent({ rootState, commit }, event) {
    const requirements = eventAction.requireFor(rootState, event);
    if (!requirements) return;

    const list = requirements.list;
    const card = requirements.card;

    switch (event.action) {
      case eventAction.card.alarm.new:
      case eventAction.list.alarm.new: {
        event.data = JSON.parse(event.data);
        const newAlarm = {
          id: event.param1,
          enabled: !!event.data.enabled,
          time: event.param2,
          month_days: event.data.month_days || 0,
          days: event.param3,
          greeting: event.data.greeting || "",
          zone: event.data.zone,
          list_id: list.id
        };
        if (card) {
          newAlarm.card_id = card.id;
        }
        commit("ADD", {
          list: list,
          card: card,
          alarm: newAlarm
        });
        break;
      }
      case eventAction.card.alarm.update:
      case eventAction.list.alarm.update: {
        event.data = JSON.parse(event.data);
        const alarmsToUse = card ? card.alarms : list.alarms;
        const existing = alarmsToUse.find(a => a.id == event.param1);
        if (existing) {
          existing.enabled = !!event.data.enabled;
          existing.time = event.param2;
          existing.month_days = event.data.month_days || 0;
          existing.days = event.param3;
          existing.greeting = event.data.greeting || "";
          existing.zone = event.data.zone;
        }
        break;
      }
    }
  }
};

function add(state, list, card, alarm) {
  if (!alarm) return;

  if (!alarm.id) {
    console.error("Cant add alarm without id", alarm);
    return;
  }

  if (!list && !card) {
    console.error("list is not existing for alarm", alarm);
    return;
  }

  alarm.type = "alarm";

  const obj = card || list;
  if (!obj.alarms) obj.alarms = [];

  if (obj.alarms.find(a => a.id == alarm.id)) {
    return;
  }

  obj.alarms.push(alarm);
}

// mutations
const mutations = {
  ADD_RANGE(state, items /* [{ list, alarm }] */) {
    items.forEach(i => {
      add(state, i.list, i.card, i.alarm);
    });
  },
  ADD(state, { list, card, alarm }) {
    add(state, list, card, alarm);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
